// ./src/utils/crewLanding.ts
//
// Where a crew member LANDS on an event, and which page a stall's voucher redeemer may be on at all (owner, 2026-10-18: "a
// crew role solely for vouchers redemptions so they cannot see any other pages … a person from a venue who should not
// have access to anything else"). ONE rule for the crew sign-in page, "My crew events" and the layout that keeps a
// redeemer on their page. Pure (no imports), so the guards run it.
// ⚠ The SERVER is the gate — a redeemer's every other read is refused there; this only keeps the app from showing pages
//   that would sit empty.

export const VOUCHER_REDEEMER_ROLE = "voucher_redeemer";

/** The Redeem Vouchers page of an event. */
export const voucherRedeemPath = (eventId: string): string => `/events/${eventId}/registration/coupons/redeem`;

/** Where a crew member with `role` lands on an event: a voucher redeemer on Redeem Vouchers, everyone else the guest list. */
export const crewLandingPath = (eventId: string, role: string | null | undefined): string =>
  role === VOUCHER_REDEEMER_ROLE ? voucherRedeemPath(eventId) : `/events/${eventId}/guests`;

/**
 * Where a voucher redeemer must be sent instead of `pathname` — null when they may stay (their event's Redeem Vouchers
 * page, or a page outside the app shell such as signing out). `eventId` is the event they redeem for.
 */
export const redeemerRedirect = (pathname: string, eventId: string | null | undefined): string | null => {
  if (!eventId) {
    return null;
  }

  const home = voucherRedeemPath(eventId);

  return pathname === home || pathname === `${home}/` ? null : home;
};
